/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import {
  ADMIN_ROLE,
  SUPER_ADMIN_ROLE,
  USER_ROLE,
  DEMO_ROLE,
  PREFERRED_ROLE,
  PREFERRED_ADMIN_ROLE,
} from 'modules/common/constants/roles';
/**
 * User roles for dropdowns are defined here
 */
const ROLE_NAMES = [
  { label: 'General User', key: USER_ROLE },
  { label: 'Admin User', key: ADMIN_ROLE },
  { label: 'Super Admin User', key: SUPER_ADMIN_ROLE },
  { label: 'Demo User', key: DEMO_ROLE },
  { label: 'Preferred User', key: PREFERRED_ROLE },
  { label: 'Preferred Admin', key: PREFERRED_ADMIN_ROLE },
];
//
export default ROLE_NAMES;
